/**
 * Svelte use: action for touch swipe detection.
 * Ported from public/main.js (lines 529-573).
 *
 * Usage:
 *   <div use:swipe={{ onSwipeLeft, onSwipeRight, threshold: 50 }}>
 *
 * @param {HTMLElement} node
 * @param {{ onSwipeLeft?: () => void, onSwipeRight?: () => void, threshold?: number }} options
 */
export function swipe(node, options = {}) {
  let { onSwipeLeft, onSwipeRight, threshold = 50 } = options;

  let startX = 0;
  let startY = 0;
  let endX = 0;
  let endY = 0;
  let isSwiping = false;

  function handleTouchStart(e) {
    if (e.touches.length !== 1) return;
    startX = e.touches[0].screenX;
    startY = e.touches[0].screenY;
    endX = startX;
    endY = startY;
    isSwiping = true;
    node.classList.remove('swiping-x');
  }

  function handleTouchMove(e) {
    if (!isSwiping || e.touches.length !== 1) return;
    endX = e.touches[0].screenX;
    endY = e.touches[0].screenY;

    const deltaX = endX - startX;
    const deltaY = endY - startY;

    // Horizontal swipe detected — prevent vertical scroll
    if (Math.abs(deltaX) > Math.abs(deltaY) + 10) {
      node.classList.add('swiping-x');
      if (Math.abs(deltaX) > threshold / 3) {
        e.preventDefault();
      }
    } else {
      node.classList.remove('swiping-x');
    }
  }

  function handleTouchEnd() {
    if (!isSwiping) return;
    isSwiping = false;
    node.classList.remove('swiping-x');

    const deltaX = endX - startX;
    const deltaY = endY - startY;

    if (Math.abs(deltaX) > threshold && Math.abs(deltaX) > Math.abs(deltaY)) {
      if (deltaX < 0) {
        onSwipeLeft?.();
      } else {
        onSwipeRight?.();
      }
    }
  }

  node.addEventListener('touchstart', handleTouchStart, { passive: true });
  node.addEventListener('touchmove', handleTouchMove, { passive: false });
  node.addEventListener('touchend', handleTouchEnd);

  return {
    update(newOptions) {
      onSwipeLeft = newOptions.onSwipeLeft;
      onSwipeRight = newOptions.onSwipeRight;
      if (newOptions.threshold != null) threshold = newOptions.threshold;
    },
    destroy() {
      node.removeEventListener('touchstart', handleTouchStart);
      node.removeEventListener('touchmove', handleTouchMove);
      node.removeEventListener('touchend', handleTouchEnd);
      node.classList.remove('swiping-x');
    },
  };
}
